import Attachments from "./AttachmentsContainer";

export default Attachments;
